import { applyMiddleware, createStore } from 'redux';
import rootReducer from '../reducers';
import thunk from 'redux-thunk'
// alt vor middlewwareconst store = createStore(rootReducer);
import { composeWithDevTools } from 'redux-devtools-extension'; //redux dev tool extention

const store = createStore(rootReducer, composeWithDevTools(
    applyMiddleware(thunk),

))
export const dispatch = store.dispatch
export default store


/* alt bevor install dev tools 
const createStoreWithMiddleware = applyMiddleware(thunk)(createStore)

export default createStoreWithMiddleware(rootReducer)
*/

// alt vor middleware export default store


// WEBPACK FOOTER //
// ./src/store/index.js